<template>
  <div class="live_important_things">
    <ul class="team_name_logo">
      <li>
        <span class="logo">
          <img v-if="matchInfo.home_logo.length > 0" :src="matchInfo.home_logo" />
          <img v-else src="./img/football.png" />
        </span>
        <strong>{{ matchInfo.home }}</strong>
      </li>
      <li class="last">
        <span class="logo">
          <img v-if="matchInfo.away_logo.length > 0" :src="matchInfo.away_logo" />
          <img v-else src="./img/football.png" />
        </span>
        <strong>{{ matchInfo.away }}</strong>
      </li>
    </ul>

    <div v-loading="loading">
      <div class="important_line_time" v-if="importantDataList.length > 0">
        <span class="icon_circle"></span>
        <span class="icon_circle_footer"></span>
        <div v-for="(item, index) of importantDataList" :key="index">
          <div v-if="[6, 7, 10, 11, 12, 13, 19, 23, 24, 25, 26, 27, 29, 30].includes(item.type)" class="row_full">
            <span class="status">{{ fballTypes[item.type].name }}</span>
          </div>

          <template v-if="[1, 2, 3, 4, 5, 8, 9, 15, 16, 17, 18, 21, 22, 28].includes(item.type)">
            <div v-if="item.position == 1" class="row_left">
              <strong class="ball_score_red">{{ item.time }}</strong>
              <div class="match_remark">
                <div class="remark">
                  <!--足球文字直播没有比分数据-->
                  <h3 v-show="false">{{ item.home_score }} - {{ item.away_score }}</h3>
                  <p>{{ item.data }}</p>
                </div>
                <span class="icon"><img :src="require(`./img/match_status/${fballTypes[item.type].icon}.png`)" /></span>
              </div>
            </div>

            <div v-else class="row_right">
              <strong class="ball_score_blue">{{ item.time }}</strong>
              <div class="match_remark">
                <span class="icon"><img :src="require(`./img/match_status/${fballTypes[item.type].icon}.png`)" /></span>
                <div class="remark">
                  <!--足球文字直播没有比分数据-->
                  <h3 v-show="false">{{ item.home_score }} - {{ item.away_score }}</h3>
                  <p>{{ item.data }}</p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="importantDataList.length == 0 && loading == false">
      <panel-not-data message="当前赛事没有关键事件数据..." img-name="empty" />
    </div>
    <!--足球图示-->
    <football-icons />
  </div>
</template>

<script>
//引入足球图标
import FootballIcons from "./fball_icons";
//引入公用无数据组件
import PanelNotData from "@/components/match-recommend/not-data";

export default {
  name: "FootballImportant",
  data() {
    return {
      loading: true,
      //关键事件数据
      importantDataList: [],
      footballTypes: {},
    };
  },
  components: {
    FootballIcons,
    PanelNotData,
  },
  props: {
    matchInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fballTypes: {
      type: Object,
    },
  },
  mounted() {
    //增加强行关闭动画的定时器
    setTimeout(() => {
      this.loading = false;
    }, 20000);
  },
  methods: {
    /**
     * 关键事件内容处理
     * @param {string} ret_data 接口发过来的json字符串
     */
    runData(ret_data) {
      let live_data_list = JSON.parse(ret_data.replace(/[\\]+/g, "").slice(1, -1));
      
      if (live_data_list.length > 0) {
        console.log("main=1是关键事件，仅针对足球:", live_data_list);
        //main等于1是关键事件，但是后来和产品确认了，不区分直接显示
        this.importantDataList = live_data_list[0].text_live.reverse();
        // console.log("关键事件数据：", this.importantDataList);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
//[足球-关键事件]对应的内容块部分
.live_important_things {
  clear: both;
  width: 100%;
  min-height: 300px;
  overflow: hidden;
}
.important_line_time {
  clear: both;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0.08rem 0.6rem;
  position: relative;

  &::before {
    content: "";
    display: block;
    width: 0px;
    height: 100%;
    overflow: hidden;
    margin: 0 auto;
    border-left: 1px solid #dbdbdb;
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
  }

  .icon_circle,
  .icon_circle_footer {
    display: block;
    clear: both;
    width: 8px;
    height: 8px;
    overflow: hidden;
    background-color: #dbdbdb;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 0 auto;
    position: absolute;
    z-index: 5;
    left: 0;
    right: 0;
    top: 0;
  }

  .icon_circle_footer {
    top: auto;
    bottom: 0;
  }

  .row_full,
  .row_left,
  .row_right {
    clear: both;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 15px 0px;
    position: relative;
  }

  .row_full {
    text-align: center;
  }

  .row_full .status {
    display: inline-block;
    width: auto;
    height: 0.22rem;
    line-height: 0.22rem;
    overflow: hidden;
    background-color: #dbdbdb;
    box-sizing: border-box;
    border-radius: 0.2rem;
    padding: 0px 0.15rem;
    font-size: 0.12rem;
    color: #666;
    margin: 0 auto;
  }

  .row_left {
    padding-right: calc(50% + 0.2rem);
  }

  .row_right {
    padding-left: calc(50% + 0.2rem);
  }

  .ball_score_blue,
  .ball_score_red {
    display: block;
    clear: both;
    width: auto;
    min-width: 0.28rem;
    height: 0.28rem;
    line-height: 0.28rem;
    overflow: hidden;
    background-color: #3c9cfe;
    border-radius: 0.2rem;
    margin: auto 0px;
    font-size: 0.12rem;
    color: #fff;
    text-align: center;
    position: absolute;
    z-index: 5;
    top: 0.22rem;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .ball_score_red {
    background-color: #db6372;
  }

  .match_remark {
    display: flex;
    align-items: center;
    clear: both;
    width: 100%;
    line-height: 0.24rem;
    overflow: hidden;
    background-color: #f9f9fb;
    padding: 0.2rem 0.1rem;
    box-sizing: border-box;
    border-radius: 10px;
    font-size: 0.16rem;

    .icon {
      display: block;
      float: left;
      width: 0.3rem;
      height: 0.25rem;
      overflow: hidden;

      img {
        display: block;
        height: 100%;
        margin: 0 auto;
      }
    }

    .remark {
      padding: 0px 10px;
      overflow: hidden;

      h3 {
        clear: both;
        width: 100%;
        overflow: hidden;
        color: #db6372;
      }

      p {
        clear: both;
        width: 100%;
        overflow: hidden;
        color: #000;
      }
    }
  }

  .row_left .match_remark {
    justify-content: right;
    text-align: right;
  }
}
</style>